/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterE = createReactComponent("letter-e", "IconLetterE", [
  ["path", { d: "M17 4h-10v16h10", key: "svg-0" }],
  ["path", { d: "M7 12l8 0", key: "svg-1" }]
]);

export { IconLetterE as default };
//# sourceMappingURL=IconLetterE.js.map
